var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-center-page"},[_c('p',{staticClass:"bread-tab"},[_c('span',[_vm._v("数据中心/")]),_c('span',{staticClass:"bd"},[_vm._v(_vm._s(_vm.tabName))])]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }